module.exports = __webpack_public_path__ + "img/home_img_kaifang.1bf37e8b.png";